import { DisplayConfig, FieldConfig } from "./types";

interface CoverPageFieldConfig extends FieldConfig {
    addressType?: "subject" | "amazon";
    groupLabel?: string;
}

export const coverPageConfig: CoverPageFieldConfig[][] = [
    [
        {
            label: "Appeals to",
            field: "appealTo",
            placeholder: "Enter new Appeals to",
        },
    ],
    [
        {
            label: "Subject Property Number",
            field: "subjectPropertyNumber",
            placeholder: "Enter Subject Property Number",
        },
    ],
    [
        {
            label: "Subject Property Owner",
            field: "subjectPropertyOwner",
            placeholder: "Enter Subject Property Owner",
        },
    ],
    [
        {
            groupLabel: "Subject Property Address",
            label: "Street Address",
            field: "streetaddress",
            placeholder: "Street Address",
            nested: {
                parent: "subjectPropertyAddress",
                field: "streetaddress",
            },
        },
    ],
    [
        {
            label: "City",
            field: "city",
            placeholder: "City",
            nested: {
                parent: "subjectPropertyAddress",
                field: "city",
            },
        },
        {
            label: "State",
            field: "state",
            placeholder: "State",
            nested: {
                parent: "subjectPropertyAddress",
                field: "state",
            },
        },
        {
            label: "Zip Code",
            field: "zipCode",
            placeholder: "Zip Code",
            nested: {
                parent: "subjectPropertyAddress",
                field: "zipCode",
            },
        },
    ],
    [
        {
            label: "County",
            field: "county",
            placeholder: "County",
            nested: {
                parent: "subjectPropertyAddress",
                field: "county",
            },
        },
        {
            label: "Country",
            field: "country",
            placeholder: "Country",
            nested: {
                parent: "subjectPropertyAddress",
                field: "country",
            },
        },
    ],
    [
        {
            groupLabel: "Amazon Address",
            label: "PO Box Number",
            field: "poBoxNumber",
            placeholder: "PO Box Number",
            nested: {
                parent: "amazonAddress",
                field: "poBoxNumber",
            },
        },
    ],
    [
        {
            label: "City",
            field: "city",
            placeholder: "City",
            nested: {
                parent: "amazonAddress",
                field: "city",
            },
        },
        {
            label: "State",
            field: "state",
            placeholder: "State",
            nested: {
                parent: "amazonAddress",
                field: "state",
            },
        },
        {
            label: "Zip Code",
            field: "zipCode",
            placeholder: "Zip Code",
            nested: {
                parent: "amazonAddress",
                field: "zipCode",
            },
        },
    ],
    [
        {
            label: "Hearing Date",
            field: "hearingDate",
            placeholder: "Enter new Hearing Date",
            type: "date",
        },
        {
            label: "Hearing Time",
            field: "hearingTime",
            placeholder: "Enter new Hearing Time",
            type: "time",
        },
    ],
    [
        {
            label: "Presenter",
            field: "presenter",
            placeholder: "Enter Presenter",
        },
    ],
    [
        {
            label: "Contact Information",
            field: "contactInformation",
            placeholder: "Enter Contact Information",
        },
    ],
];

export const displayCoverPageConfig: DisplayConfig[] = [
    {
        id: "header",
        type: "header",
        title: "Cover Page",
    },
    {
        id: "appealsTo",
        type: "single",
        label: "Appeals To",
        field: "appealTo",
    },
    {
        id: "addresses",
        type: "row",
        items: [
            {
                label: "Subject Property",
                type: "address",
                addressType: "subjectPropertyAddress",
                fields: [
                    "streetaddress",
                    "addressLineTwo",
                    "county",
                    "city",
                    "state",
                    "zipCode",
                    "country",
                ],
            },
            {
                label: "Amazon Address",
                type: "address",
                addressType: "amazonAddress",
                fields: ["poBoxNumber", "city", "state", "zipCode"],
            },
        ],
    },
    {
        id: "hearing",
        type: "row",
        items: [
            {
                label: "Hearing Date",
                field: "hearingDate",
            },
            {
                label: "Hearing Time",
                field: "hearingTime",
            },
        ],
    },
    {
        id: "contact",
        type: "row",
        items: [
            {
                label: "Presenter",
                field: "presenter",
            },
            {
                label: "Contact Information",
                field: "contactInformation",
            },
        ],
    },
];
